export const rootPath = '/pilot-line/lines';
export const entityPath = '/pilot-line/lines/:id';

export const addTitle = 'Add Pilot Line';
export const editTitle = 'Editing Pilot Line';
export const listTitle = 'Pilot Lines';
export const addButtonText = 'Add Line';
export const i18Namespace = 'PilotLineLines';
